import { render, staticRenderFns } from "./SalesByChannel.vue?vue&type=template&id=49223cdf&scoped=true"
import script from "./SalesByChannel.vue?vue&type=script&lang=js"
export * from "./SalesByChannel.vue?vue&type=script&lang=js"
import style0 from "./SalesByChannel.vue?vue&type=style&index=0&id=49223cdf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49223cdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49223cdf')) {
      api.createRecord('49223cdf', component.options)
    } else {
      api.reload('49223cdf', component.options)
    }
    module.hot.accept("./SalesByChannel.vue?vue&type=template&id=49223cdf&scoped=true", function () {
      api.rerender('49223cdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/SalesByChannel.vue"
export default component.exports